/// <amd-module name="Agile/Sprints/Dialog/SprintPaneWrapper" />
import * as React from "react";
import { WrappedComponent } from "VSS/Platform/Layout";
import { IPanelProps } from "VSSUI/Panel";
import { IBackcompatIteration } from "Agile/Sprints/Dialog/Contracts";
import { ITeam } from "Agile/Contracts/Common";

export interface ISprintPaneWrapperProps extends IPanelProps {
    /** The team context for the new sprint form */
    currentTeam?: ITeam;

    /** The id of the iteration to edit. If undefined, a new iteration will be created */
    editingIterationId?: string;

    /** Callback for when the iteration was created/subscribed to */
    onCompleted?: (team: ITeam, iteration: IBackcompatIteration) => void;
}

export class SprintPaneWrapper extends React.Component<ISprintPaneWrapperProps> {
    public render(): JSX.Element {
        return (
            <WrappedComponent
                wrappedType="legacy"
                dependencies={["ms.vss-web.legacy-content"]}
                wrappedProps={{
                    componentType: "sprintPane",
                    modules: ["Agile/Scripts/SprintsHub/SprintEditor/Components/SprintEditorPane"],
                    ...this.props
                }}
            />
        );
    }
}
